<template>
	<el-row class="container">
		<el-col :span="24" class="header">
			<el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
				{{collapsed?'':sysName}}
				<img :src="logourl" alt=""/>
			</el-col>
			<!--<el-col :span="10">-->
				<!--<div class="tools" @click.prevent="collapse">-->
					<!--<i class="fa fa-align-justify"></i>-->
				<!--</div>-->
			<!--</el-col>-->
			<el-col :span="10" class="userinfo">
				<el-dropdown trigger="hover">
					<span class="el-dropdown-link userinfo-inner"><!-- <img :src="this.sysUserAvatar" /> -->{{sysUserName}}
					</span>
					<el-dropdown-menu slot="dropdown">
						<!-- <el-dropdown-item>我的消息</el-dropdown-item>
						<el-dropdown-item>设置</el-dropdown-item>
						-->
						<el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-col>
		</el-col>
		<el-col :span="24" class="main">
			<aside :class="collapsed?'menu-collapsed':'menu-expanded'" >
				<el-menu :default-active="$route.fullPath" class="el-menu-vertical-demo" @open="handleopen" @close="handleclose" @select="handleselect"
					 active-text-color="white" unique-opened router v-show="!collapsed" >
					<template v-for="(item,index) in menus" v-if="!item.hidden">
						<el-submenu :index="index+''" v-if="!item.leaf">
							<template slot="title" ><i :class="item.iconCls"  ></i>{{item.name}}</template>
							<el-menu-item v-for="child in item.children" :index="child.path" :key="child.path" v-if="!child.hidden"   >{{child.name}}</el-menu-item>
						</el-submenu>
						<el-menu-item v-if="item.leaf&&item.children.length >0" :index="item.children[0].path" ><i :class="item.iconCls"  ></i>{{item.children[0].name}}</el-menu-item>
					</template>
				</el-menu>
				
				<!--导航菜单-->
				<!-- 
				<el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleopen" @close="handleclose" @select="handleselect"
					 unique-opened router v-show="!collapsed">
					<template v-for="(item,index) in $router.options.routes" v-if="!item.hidden">
						<el-submenu :index="index+''" v-if="!item.leaf">
							<template slot="title" ><i :class="item.iconCls" ></i>{{item.name}}</template>
							<el-menu-item v-for="child in item.children" :index="child.path" :key="child.path" v-if="!child.hidden">{{child.name}}</el-menu-item>
						</el-submenu>
						<el-menu-item v-if="item.leaf&&item.children.length >0" :index="item.children[0].path" ><i :class="item.iconCls" ></i>{{item.children[0].name}}</el-menu-item>
					</template>
				</el-menu>
				-->
			</aside>
			<section class="content-container">
				<el-tabs
					v-model="activeIndex"
					type="border-card"
					@tab-remove="removeTab"
					@tab-click="clickTab">
					<el-tab-pane
						:key="item.name"
						v-for="item in openTab"
						:label="item.title"
						:name="item.name"
						:closable="item.closable">
						<router-view v-if="item.isfush"></router-view>
					</el-tab-pane>
				</el-tabs>
				<!--
				<div class="grid-content bg-purple-light">
					<el-col :span="24" class="breadcrumb-container">
						<strong class="title">{{$route.name}}</strong>
						
						<el-breadcrumb separator="/" class="breadcrumb-inner">
							<el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
								{{ item.name }}
							</el-breadcrumb-item>
						</el-breadcrumb>
					</el-col>
					<el-col :span="24" class="content-wrapper">
						<transition name="fade" mode="out-in">
							<router-view></router-view>
						</transition>
					</el-col>
				</div>
				-->
			</section>
		</el-col>
	</el-row>
</template>

<script>
	import { getMenu } from '../api/api';
	
	export default {
		data() {
			return {
				sysName:'数据查询',
				collapsed:false,
				sysUserName: '',
				sysUserAvatar: '',
				menus:[],
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				},
				logourl:require("../assets/logo.png"),
				activeIndex: '/Index',
				openTab: [
					{
						title: '首页',
						name: '/Index',
						closable: false,
						isfush:false
					}
				]
			}
		},
		watch: {
			$route(to, form) {
				/**
				var flag = false;
				for (let i = 0; i < this.openTab.length; i++) {
					if (to.fullPath == this.openTab[i].name) {
						this.activeIndex = this.openTab[i].name;
						flag = true;
						break;
					}
				}
				if (!flag) {
					var showTitle = '';
					for(let i=0;i<this.menus.length;i++){
						for(let j=0;j<this.menus[i].children.length;j++){
							if(this.menus[i].children[j].path==to.fullPath){
								showTitle = this.menus[i].children[j].name ;
								break;
							}
							//console.log();
						}
					}
					let obj = {
						title: showTitle,
						name: to.fullPath,
						closable: true
					};
					console.log(to);
					this.activeIndex = to.fullPath;
					this.openTab.push(obj);
				}
				*/
				this.isAddPanel(to.fullPath);
			}
		},
		methods: {
			isAddPanel(fullPath){
				var flag = false;
				// 当前页面菜单已打开
				for (let i = 0; i < this.openTab.length; i++) {
					if (fullPath == this.openTab[i].name) {
						this.activeIndex = this.openTab[i].name;
						flag = true;
						this.openTab[i].isfush = true;
						//break;
					}else{
						this.openTab[i].isfush = false;
					}
				}
				// 打开新的页面
				if (!flag) {
					var showTitle = '';
					for(let i=0;i<this.menus.length;i++){
						for(let j=0;j<this.menus[i].children.length;j++){
							if(this.menus[i].children[j].path==fullPath){
								showTitle = this.menus[i].children[j].name ;
								break;
							}
							//console.log();
						}
					}
					let obj = {
						title: showTitle,
						name: fullPath,
						closable: true,
						isfush:true
					};
					this.activeIndex = fullPath;
					this.openTab.push(obj);
				}
			},
			clickTab(tab) {
				this.activeIndex = tab.paneName;
				this.$router.push({ path: this.activeIndex });
				//this.isAddPanel(this.$route.fullPath);
				
			},
			removeTab(target) {
				// 删除的是当前选中的页面
				if (this.activeIndex === target) {
					this.openTab.forEach((item, index) => {
						if (item.name == target) {
							let nextTab = item[index + 1] || item[index - 1];
							if (nextTab) {
								this.activeIndex = nextTab.name;
							}
						}
					});
				}
				var i = 0;
				this.openTab.forEach((item, index) => {
					if (item.name == target) {
						// eslint-disable-next-line no-return-assign
						return (i = index);
					}
				});
				this.openTab.splice(i, 1);
				// 更新路由
				this.$router.push({ path: this.openTab[this.openTab.length - 1].name });
			},
			onSubmit() {
				//console.log('submit!');
			},
			handleopen() {
				//console.log('handleopen');
			},
			handleclose() {
				//console.log('handleclose');
			},
			handleselect: function (a, b) {
				//console.log('handleselect>>'+a+'>>'+b+'>>'+this.$route.fullPath);
				//this.isAddPanel(a);
			},
			//退出登录
			logout: function () {
				var _this = this;
				this.$confirm('确认退出吗?', '提示', {
					//type: 'warning'
				}).then(() => {
					sessionStorage.removeItem('user');
					_this.$router.push('/login');
				}).catch(() => {

				});
			},
			//折叠导航栏
			collapse:function(){
				this.collapsed=!this.collapsed;
			},
			showMenu(i,status){
				this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-'+i)[0].style.display=status?'block':'none';
			},
			//获取菜单表
			getMenu() 
			{
				getMenu().then((res) => {
					//this.total = res.data.total;
					//this.users = res.data.users;
					//this.listLoading = false;
					//NProgress.done();
				});
			}
		},
		mounted() {
			var user = sessionStorage.getItem('user');
			if (user) {
				user = JSON.parse(user);
				//console.log("user="+JSON.stringify(user));
				this.sysName = user.sysname;
				this.sysUserName = user.name || '';
				this.menus = user.menus ;
				//console.log(">>>menu:"+JSON.stringify(this.menus));
				//this.sysUserAvatar = user.avatar || '';
			}
			/**
			window.addEventListener('beforeunload', e => {
				sessionStorage.setItem(
					'openTab',
					JSON.stringify({
						openTab: this.openTab.filter(
							item => item.name != '/index'
						),
						openTabPath: this.openTab.filter(
							item => item.name !== '/index'
						),
						currActiveTabs: this.activeIndex
					})
				);
			});
			*/
			console.log('刷新:'+this.$route.fullPath);
			this.isAddPanel(this.$route.fullPath);
		}
	}

</script>

<style lang="scss">
	@import '~scss_vars';
	.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		.header {
			height: 60px;
			line-height: 60px;
			background: $color-primary;
			color:#fff;
			.userinfo {
				text-align: right;
				padding-right: 35px;
				float: right;
				.userinfo-inner {
					cursor: pointer;
					color:#fff;
					img {
						width: 40px;
						height: 40px;
						border-radius: 20px;
						margin: 10px 0px 10px 10px;
						float: right;
					}
				}
			}
			.logo {
				/* //width:230px; */
				height:60px;
				font-size: 18px;
				padding-left:20px;
				padding-right:20px;
				border-color: rgba(238,241,146,0.3);
				border-right-width: 1px;
				border-right-style: solid;
				img {
					float: left;
					width: 60px;
					margin:8px 0 0 -20px;
				}
				.txt {
					color:#fff;
				}
			}
			.logo-width{
				width:230px;
			}
			.logo-collapse-width{
				width:60px
			}
			.tools{
				padding: 0px 23px;
				width:14px;
				height: 60px;
				line-height: 60px;
				cursor: pointer;
			}
		}
		.main {
			display: flex;
			// background: #324057;
			position: absolute;
			top: 60px;
			bottom: 0px;
			overflow: hidden;
			aside {
				flex:0 0 230px;
				width: 230px;
				// position: absolute;
				// top: 0px;
				// bottom: 0px;
				.el-menu{
					height: 100%;
				}
				.collapsed{
					width:60px;
					.item{
						position: relative;
					}
					.submenu{
						position:absolute;
						top:0px;
						left:60px;
						z-index:99999;
						height:auto;
						display:none;
					}

				}
			}
			.menu-collapsed{
				flex:0 0 60px;
				width: 60px;
			}
			.menu-expanded{
				flex:0 0 230px;
				width: 230px;
			}
			.content-container {
				// background: #f1f2f7;
				flex:1;
				// position: absolute;
				// right: 0px;
				// top: 0px;
				// bottom: 0px;
				// left: 230px;
				overflow-y: scroll;
				//padding: 20px;
				.breadcrumb-container {
					//margin-bottom: 15px;
					.title {
						width: 200px;
						float: left;
						color: #475669;
					}
					.breadcrumb-inner {
						float: right;
					}
				}
				.content-wrapper {
					background-color: #fff;
					box-sizing: border-box;
				}
			}
		}
	}
	.el-menu{
		height:100%;
		.el-menu-item.is-active{
			background-color:#d9d9d9 !important;
		}
	}
	.el-table th {
	  background-color: #7a8295 !important; /* 背景颜色 */
	  color: #fff !important; /* 文字颜色 */
	}
	//.el-table{
	//	border: 0px solid; 
	//}
	.breadcrumb-container {
		height:35px;
	}
	.toolbar .el-form-item {
		margin-bottom: 10px;
	}
</style>


// WEBPACK FOOTER //
// Home.vue?770d23d4